import React from 'react';

import { SvgIcon } from 'components/icons/SvgIcon';

export const VaultMessage: React.FC = () => {
  return (
    <div className='text-center auto-margin py-4' style={{ maxWidth: 780 }}>
      <SvgIcon icon='vault' className='mb-mini' style={{ fontSize: '44px', opacity: 0.5 }} />
      <div className='key-value key-value--vault mb-2'>Your Vault is empty</div>
      <p className='standfirst'>
        {
          'Your Vault is the central place where all your artworks are stored. Use it to manage your collection, create custom playlists and playback your artworks.'
        }
      </p>
    </div>
  );
};
